import {skipToken} from '@reduxjs/toolkit/query'
import * as React from 'react'

import BuildsFetcher from '../../../../../../containers/BuildsFetcher'
import {useBuildId} from '../../../../../../hooks/routes'
import {getSingleBuildArg} from '../../../../../../rest/builds'
import {getBuildTypesArg, getDependantsLocator} from '../../../../../../rest/buildTypes'
import {getBuildLocator} from '../../../../../../rest/locators'
import {getBuild} from '../../../../../../selectors'
import {restApi} from '../../../../../../services/rest'
import DependenciesChain from '../../../../BuildPage/DependenciesTab/DependenciesChain/DependenciesChain'
import {SnapshotDependenciesModes} from '../../../../BuildPage/DependenciesTab/DependenciesTab.modes'
import {getSnapshotDependenciesLocator} from '../../../../BuildPage/DependenciesTab/DependenciesTab.utils'

import styles from './BuildTypeChainContent.css'

import {useAppSelector} from 'src/hooks/react-redux'

export default function BuildTypeChainContent() {
  const buildId = useBuildId()!
  restApi.endpoints.getBuildNormalized.useQuerySubscription(
    getSingleBuildArg(getBuildLocator(buildId), {withSnapshotDependencies: true}),
  )
  const buildTypeId = useAppSelector(state => getBuild(state, buildId)?.buildType)
  restApi.endpoints.getAllBuildTypesNormalized.useQuerySubscription(
    buildTypeId != null
      ? getBuildTypesArg(getDependantsLocator(buildTypeId), {withSnapshotDependencies: true})
      : skipToken,
  )

  return React.useMemo(
    () => (
      <BuildsFetcher
        fetchCount={1000}
        withProgress={false}
        withRunning
        withQueued
        withSnapshotDependencies
        baseLocator={getSnapshotDependenciesLocator(buildId, SnapshotDependenciesModes.CHAIN)}
        projectOrBuildTypeNode={{
          nodeType: 'all',
        }}
      >
        <div className={styles.container}>
          <div className={styles.innerContainer}>
            <DependenciesChain withLegend={false} />
          </div>
        </div>
      </BuildsFetcher>
    ),
    [buildId],
  )
}
